import { useState } from 'react';
import { Link } from 'react-router-dom';
import { EMAIL_LIEN_HE, GIAI_DOAN, KET_QUA, guiCauChuyen, linkGmail } from '../lib/stories.js';

const TRONG = { hoTen: '', lienHe: '', congTy: '', nganh: '', giaiDoan: GIAI_DOAN[1], ketQua: KET_QUA[3], tieuDe: '', cauChuyen: '', baiHoc: '', anDanh: false, dongY: false, chophepLienHe: false };

const GOI_Y = [
  'Bối cảnh lúc đó: ngành gì, mấy người, còn bao nhiêu tiền mặt, đang ở vòng nào.',
  'Quyết định khó bạn phải chọn, và vì sao cả hai hướng đều có giá.',
  'Điều không như dự tính: bị từ chối thế nào, câu hỏi nào làm bạn đứng hình.',
  'Bước ngoặt: điều gì đã thay đổi cục diện.',
  'Kết quả thật, kể cả khi vòng gọi vốn không thành.',
];

export default function StorySubmit() {
  const [form, setForm] = useState(TRONG);
  const [state, setState] = useState('idle');
  const [message, setMessage] = useState('');
  const set = (k, v) => setForm((old) => ({ ...old, [k]: v }));

  async function submit(e) {
    e.preventDefault();
    setState('sending'); setMessage('');
    try { await guiCauChuyen(form); setState('done'); }
    catch (err) { setState('idle'); setMessage(err.message); }
  }

  if (state === 'done') return <section className="surface story-done">
    <h1>Cảm ơn bạn đã kể</h1>
    <p>Chúng tôi đã nhận được câu chuyện. Một người trong nhóm biên tập sẽ liên hệ với bạn để làm rõ vài chi tiết và gửi bạn xem bản cuối. <strong>Bài chỉ được đăng khi bạn đồng ý bản cuối đó.</strong></p>
    <p className="nho">Thường mất 3–5 ngày làm việc. Nếu cần bổ sung gì, bạn cứ gửi thêm về {EMAIL_LIEN_HE}.</p>
    <div className="hang-nut"><Link className="nut" to="/playbook">Về Playbook</Link><Link className="nut phu" to="/cong-cu">Xem bộ công cụ</Link></div>
  </section>;

  return <div className="story-form-page">
    <header className="page-heading">
      <p className="eyebrow"><Link to="/playbook">Playbook</Link> / Góp một câu chuyện</p>
      <h1>Kể lại lần gọi vốn của bạn</h1>
      <p className="lead">Không cần văn hay, không cần dài. Chỉ cần thật. Chúng tôi sẽ biên tập lại cùng bạn, và bạn có toàn quyền quyết định bản cuối.</p>
    </header>

    <div className="story-layout">
      <form className="surface story-form" onSubmit={submit}>
        <fieldset>
          <legend>Câu chuyện</legend>
          <label htmlFor="tieu-de">Một câu tóm lại chuyện gì đã xảy ra <span className="nho">(không bắt buộc)</span></label>
          <input id="tieu-de" type="text" value={form.tieuDe} placeholder="Ví dụ: Bị từ chối ba lần vì không trả lời được câu hỏi ai trả tiền" onChange={(e) => set('tieuDe', e.target.value)} />

          <label htmlFor="cau-chuyen">Chuyện đã diễn ra thế nào? <span className="nho">(bắt buộc)</span></label>
          <textarea id="cau-chuyen" rows="12" value={form.cauChuyen} onChange={(e) => set('cauChuyen', e.target.value)}
            placeholder="Cứ viết như đang kể cho một người bạn cũng đang gọi vốn…" required />
          <p className="nho story-dem">{form.cauChuyen.trim().length}/6000 ký tự{form.cauChuyen.trim().length < 150 && ', cần ít nhất 150'}</p>

          <label htmlFor="bai-hoc">Nếu làm lại, bạn sẽ làm khác điều gì? <span className="nho">(không bắt buộc)</span></label>
          <textarea id="bai-hoc" rows="4" value={form.baiHoc} onChange={(e) => set('baiHoc', e.target.value)} />
        </fieldset>

        <fieldset>
          <legend>Bối cảnh</legend>
          <div className="o-nhap">
            <div><label htmlFor="nganh">Ngành</label><input id="nganh" type="text" value={form.nganh} placeholder="SaaS, F&B, logistics…" onChange={(e) => set('nganh', e.target.value)} /></div>
            <div><label htmlFor="giai-doan">Bạn đang ở đâu</label><select id="giai-doan" value={form.giaiDoan} onChange={(e) => set('giaiDoan', e.target.value)}>{GIAI_DOAN.map((x) => <option key={x}>{x}</option>)}</select></div>
            <div><label htmlFor="ket-qua">Kết quả</label><select id="ket-qua" value={form.ketQua} onChange={(e) => set('ketQua', e.target.value)}>{KET_QUA.map((x) => <option key={x}>{x}</option>)}</select></div>
            <div><label htmlFor="cong-ty">Công ty <span className="nho">(không bắt buộc)</span></label><input id="cong-ty" type="text" value={form.congTy} onChange={(e) => set('congTy', e.target.value)} /></div>
          </div>
        </fieldset>

        <fieldset>
          <legend>Liên hệ và quyền của bạn</legend>
          <div className="o-nhap">
            <div><label htmlFor="ho-ten">Tên bạn</label><input id="ho-ten" type="text" value={form.hoTen} onChange={(e) => set('hoTen', e.target.value)} /></div>
            <div><label htmlFor="lien-he">Email hoặc số Zalo <span className="nho">(bắt buộc)</span></label><input id="lien-he" type="text" value={form.lienHe} onChange={(e) => set('lienHe', e.target.value)} required /></div>
          </div>
          <div className="story-checks">
            <label><input type="checkbox" checked={form.anDanh} onChange={(e) => set('anDanh', e.target.checked)} /> Đăng ẩn danh: chỉ ghi kiểu “một founder ngành SaaS”, không nêu tên tôi và công ty.</label>
            <label><input type="checkbox" checked={form.chophepLienHe} onChange={(e) => set('chophepLienHe', e.target.checked)} /> Tôi đồng ý trao đổi qua một cuộc gọi ngắn nếu cần làm rõ thêm.</label>
            <label className="story-consent"><input type="checkbox" checked={form.dongY} onChange={(e) => set('dongY', e.target.checked)} required /> Tôi hiểu bài sẽ được biên tập lại và <strong>chỉ đăng sau khi tôi xem và đồng ý bản cuối</strong>{'.'}</label>
          </div>
        </fieldset>

        {message && <p className="story-loi" role="alert">{message}</p>}
        <div className="hang-nut story-actions">
          <button className="nut" type="submit" disabled={state === 'sending'}>{state === 'sending' ? 'Đang gửi…' : 'Gửi câu chuyện'}</button>
          <span className="nho">Không cần tạo tài khoản.</span>
        </div>
      </form>

      <aside className="surface story-help">
        <h2>Nên kể những gì</h2>
        <ul>{GOI_Y.map((x) => <li key={x}>{x}</li>)}</ul>
        <h2>Chúng tôi làm gì với câu chuyện</h2>
        <ul>
          <li>Biên tập lại cho gọn, giữ đúng ý bạn.</li>
          <li>Gửi bạn xem bản cuối trước khi đăng.</li>
          <li>Ẩn tên nhà đầu tư, con số hoặc chi tiết bạn không muốn công khai.</li>
          <li>Không dùng thông tin của bạn để bán hàng hay chuyển cho bên thứ ba.</li>
        </ul>
        <h2>Thích gửi email hơn?</h2>
        <p>Bạn gửi về <strong>{EMAIL_LIEN_HE}</strong> cũng được.</p>
        <p className="hang-nut">
          <a className="nut phu" href={linkGmail()} target="_blank" rel="noreferrer">Soạn thư bằng Gmail</a>
          <a className="nut phu" href={`mailto:${EMAIL_LIEN_HE}`}>Mở ứng dụng mail</a>
        </p>
      </aside>
    </div>
  </div>;
}
